import React, { Fragment } from "react";

const EmailCard = ({ emailAddress, children }) => {
  const handleEmailClick = (e) => {
    e.stopPropagation(); // Prevents Link navigation
  };
  if (!emailAddress) return <Fragment>{children}</Fragment>;
  return (
    <a
      href={`mailto:${emailAddress}`}
      onClick={handleEmailClick}
      onMouseDown={(e) => e.stopPropagation()}
      style={{cursor:'pointer'}}
    >
      {children}
    </a>
  );
};

export { EmailCard };
